import React from 'react';
import { Provider } from 'react-redux';
import { PageLayout } from '../../../../../common/components/Layout/PageLayout';
import { kpeStore } from '../../store/store';
import { DevPanel } from '../DevPanel/DevPanel';
import '../../styles/fonts.scss';
import styles from './KpeLayout.module.scss';

interface Props {
  children: React.ReactNode;
}

export function KpeLayout({ children }: Props) {
  return (
    <Provider store={kpeStore}>
      <PageLayout>
        <div className={styles.wrapper}>{children}</div>
        <DevPanel />
      </PageLayout>
    </Provider>
  );
}
